type Params = Record<string, string | number>;

type TFn = (tmpl: TemplateStringsArray | string, ...params: Params[]) => string;

// Sentinel interpolated into the {{category}} slot of a translated title, then
// split on. Lets the localized category name be positioned/styled independently
// (e.g. its own teal span, or spliced back in) while the surrounding words and
// word order come from the locale file.
export const CATEGORY_SLOT = '\u0000';

// Resolves a localized "certified refurbished <category>" style title that
// agrees in gender/number with the category. The category name is represented
// by CATEGORY_SLOT in the returned string — split it out (to style/position the
// name) or splice a localized name in.
//
// A generic per-locale template (`<baseKey> {{category}}`) covers every
// category; French defaults to masculine plural. Categories whose agreement
// differs (e.g. feminine French nouns) add a `<baseKey> <EnglishName>` override
// to the collections locale file, which wins when present. `collectionName` is
// the English name (the locale-file key); `genericTemplate` is the caller's
// already-resolved generic template (it owns the base wording).
export const resolveRefurbishedTitle = (
  t: TFn,
  baseKey: string,
  collectionName: string,
  genericTemplate: string,
): string => {
  const overrideKey = `${baseKey} ${collectionName}`;

  return t(overrideKey) === overrideKey
    ? genericTemplate
    : t(overrideKey, { category: CATEGORY_SLOT });
};
